import SecondaryButton from "./SecondaryButton"

const SmallCard = ({ title, description, imgSrc, imgAlt, btnTitle, btnHref, truncate, withPadding }: { title: string, description?: string, imgSrc?: string, imgAlt?: string, btnTitle?: string, btnHref?: string, truncate?: boolean, withPadding?: boolean }) => (
  <div className="px-6 sm:px-8 md:px-8 py-6 sm:py-10 bg-lightGray rounded-3xl flex-col-reverse md:flex-row md:items-start items-center">
    <div className={`md:text-xl font-bold mb-2${truncate ? ' truncate' : ''}`}>{title}</div>
    {description && (
      <div className={`text-grayDarkLight${withPadding ? ' mt-6 mb-6' : ''}`}>{description}</div>
    )}
    {imgSrc && (
      <img className="mt-10" src={`${imgSrc || '/headset.png'}`} alt={`${imgAlt || 'VR headset'}`} />
    )}
    {btnHref && btnTitle && (
      <div className="mt-4">
        <SecondaryButton fullWidth title={btnTitle} href={btnHref}></SecondaryButton>
      </div>
    )}
  </div>
)

export default SmallCard
